var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c(
      "div",
      { staticClass: "tw-p-6 tw-flex tw-flex-col addon-mini-league-container" },
      [
        _vm.step > 1
          ? _c(
              "v-row",
              { staticClass: "tw-flex-grow-0" },
              [
                _c("v-col", { attrs: { cols: "12", md: "6" } }, [
                  _vm.step > 1
                    ? _c(
                        "div",
                        {
                          staticClass:
                            "tw-flex tw-items-center tw-mb-2 tw-w-full"
                        },
                        [
                          _c(
                            "div",
                            {
                              staticClass:
                                "tw-bg-green-500 tw-rounded-full step-pill tw-flex tw-justify-center tw-items-center"
                            },
                            [
                              _c(
                                "span",
                                {
                                  staticClass: "tw-font-semibold tw-text-white"
                                },
                                [_vm._v("1")]
                              )
                            ]
                          ),
                          _c(
                            "span",
                            { staticClass: "tw-pl-3 tw-font-semibold tw-pr-3" },
                            [_vm._v("Parent Leagues:")]
                          ),
                          _c("span", [_vm._v(_vm._s(_vm.parentLeaguesInfo))]),
                          _c("v-spacer"),
                          _c(
                            "span",
                            {
                              staticClass:
                                "tw-font-semibold tw-text-blue-700 tw-underline tw-cursor-pointer",
                              on: {
                                click: function($event) {
                                  return _vm.setStep(1)
                                }
                              }
                            },
                            [_vm._v("edit")]
                          )
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm.step > 3
                    ? _c(
                        "div",
                        {
                          staticClass:
                            "tw-flex tw-items-center tw-mb-2 tw-w-full"
                        },
                        [
                          _c(
                            "div",
                            {
                              staticClass:
                                "tw-bg-green-500 tw-rounded-full step-pill tw-flex tw-justify-center tw-items-center"
                            },
                            [
                              _c(
                                "span",
                                {
                                  staticClass: "tw-font-semibold tw-text-white"
                                },
                                [_vm._v("2")]
                              )
                            ]
                          ),
                          _c(
                            "span",
                            { staticClass: "tw-pl-3 tw-font-semibold tw-pr-3" },
                            [_vm._v("Base Details:")]
                          ),
                          _c("v-spacer"),
                          _c(
                            "span",
                            {
                              staticClass:
                                "tw-font-semibold tw-text-blue-700 tw-underline tw-cursor-pointer",
                              on: {
                                click: function($event) {
                                  return _vm.setStep(2)
                                }
                              }
                            },
                            [_vm._v("edit")]
                          )
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm.step > 3
                    ? _c(
                        "div",
                        {
                          staticClass:
                            "tw-flex tw-items-center tw-mb-2 tw-w-full"
                        },
                        [
                          _c(
                            "div",
                            {
                              staticClass:
                                "tw-bg-green-500 tw-rounded-full step-pill tw-flex tw-justify-center tw-items-center"
                            },
                            [
                              _c(
                                "span",
                                {
                                  staticClass: "tw-font-semibold tw-text-white"
                                },
                                [_vm._v("3")]
                              )
                            ]
                          ),
                          _c(
                            "span",
                            { staticClass: "tw-pl-3 tw-font-semibold tw-pr-3" },
                            [_vm._v("Qualification Positions:")]
                          ),
                          _c("span", { staticClass: "tw-capitalize" }, [
                            _vm._v(_vm._s(_vm.qualificationRulesInfo))
                          ]),
                          _c("v-spacer"),
                          _c(
                            "span",
                            {
                              staticClass:
                                "tw-font-semibold tw-text-blue-700 tw-underline tw-cursor-pointer",
                              on: {
                                click: function($event) {
                                  return _vm.setStep(3)
                                }
                              }
                            },
                            [_vm._v("edit")]
                          )
                        ],
                        1
                      )
                    : _vm._e()
                ])
              ],
              1
            )
          : _vm._e(),
        _vm.step === 1
          ? _c("PickParentLeagues", {
              attrs: { step: _vm.step, type: "mini-league" },
              on: { parentLeaguesSelected: _vm.confirmParentLeagues }
            })
          : _vm._e(),
        _vm.step > 1 && _vm.step < 3 && !_vm.featuresAreSet
          ? _c(
              "div",
              { staticClass: "tw-flex" },
              [
                _c(
                  "v-row",
                  { staticClass: "tw-py-3" },
                  [
                    _c(
                      "v-col",
                      { attrs: { cols: "12", md: "4" } },
                      [
                        _c("BaseDetails", {
                          attrs: {
                            step: 2,
                            completed: _vm.step > 2,
                            features: _vm.features,
                            type: "mini-league"
                          },
                          on: {
                            saveBaseDetails: _vm.saveBaseDetails,
                            setStep: _vm.setStep
                          }
                        })
                      ],
                      1
                    )
                  ],
                  1
                )
              ],
              1
            )
          : _vm._e()
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }